import type { ChatMessageDTO } from '@/api/agentApi';

/**
 * 解析后端返回的会话正文 JSON。
 *
 * 返回 null 表示「这条记录没有可恢复的消息」。调用方此时必须原样保留本地缓存：
 * 写库侧对空消息列表直接跳过保存，所以正常数据不会是空数组；读到空只可能是
 * 后端异常降级或数据损坏，用它覆盖本地就会销毁这段对话在客户端仅存的那一份。
 */
export function parseConversationContent(
  content: string | null | undefined,
): ChatMessageDTO[] | null {
  const raw = typeof content === 'string' ? content.trim() : '';
  if (!raw) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return null;
  }
  if (!Array.isArray(parsed) || parsed.length === 0) return null;
  return parsed as ChatMessageDTO[];
}
